import React from 'react'
import {Layout} from 'antd'
const {Footer} = Layout

class FooterSection extends React.Component{
    constructor(props){
        super(props)
    }
    state={}
    componentDidMount(){}
    render(){
        return(
            <Footer
                style={{
                    textAlign: 'center',
                    background: '#0C3224'
                }}
            >
                <div className="text-center">
                    <span style={{color: "#fff"}}>All rights reserved.<br/>Copyright © 2019 - 2030</span>
                </div>
            </Footer>
        )
    }
}

export default FooterSection;